import React from "react";
import "./style.css";
import moment from "moment";

const TopBanner = ({ data }) => {

  const getSubmissionsText = () => {
    const dateDiff = moment().diff(data?.submission_start_date, 'seconds');
    if (moment().diff(data?.end_date, 'seconds') > 0 && !data?.is_quiz_only) {
      return `Submission not allowed`;
    } else if (dateDiff < 0 && !data?.is_quiz_only) {
      return `Submission will start on ${moment(data?.submission_start_date).format("Do MMM YYYY")}`;
    } else if (!data?.is_quiz_only) {
      return `Submission is live`;
    }
    return false;
  }

  return (
    <div className="chmpn-top-banner">
      <div class="formfram px-5" style={{ minHeight: "400px" }}>
        <div class="activity-text-container">
          {getSubmissionsText() && <div className="activity-text-title">{getSubmissionsText()}</div>}
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
